import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { type Banner } from '@sr/types';
import { useProfileV2 } from 'core/lib/Profile';
import { WithCustomerPortalApi } from 'core/lib/customerPortalApi';
import { getApiUrl } from '../utils/environment';

export const useBanners = WithCustomerPortalApi<Banner[], UseQueryResult<Banner[]>>(
  (fetchFn) => {
    const { basicProfile } = useProfileV2();

    const url = new URL(getApiUrl() + '/banners');

    url.searchParams.set('lang', basicProfile?.language ?? 'en');

    url.searchParams.append('scope', 'all');

    const query = useQuery({
      queryKey: ['banners', basicProfile?.language ?? 'en'],
      staleTime: 5 * 60 * 1000, // 5 minutes
      enabled: !!basicProfile,
      queryFn: ({ signal }) =>
        fetchFn({
          url: url.toString(),
          options: {
            method: 'GET',
            signal,
          },
        }),
      select(data) {
        return data.toSorted((a, b) => {
          const levelOrder: Record<string, number> = { error: 1, warning: 2, info: 3 };

          const levelA = a.bannerLevel ? levelOrder[a.bannerLevel.toLowerCase()] || 3 : 3;
          const levelB = b.bannerLevel ? levelOrder[b.bannerLevel.toLowerCase()] || 3 : 3;

          return levelA - levelB;
        });
      },
    });

    return query;
  },
  { hookName: 'useBanners' },
);
